<template>
  <van-popup v-model="visible" position="bottom">
    <div class="alink">
      <div class="header">
        <span class="title">账号绑定提示</span>
        <span class="close" @click.stop="close">
          <i class="el-icon-close"></i>
        </span>
      </div>
      <div class="body">
        <div class="title">检测到存在多个注册账号，请选择绑定后以哪个为准</div>
        <div class="content">
          <div class="list-item" @click="type = '1'">
            <div class="left">
              <i
                :class="[
                  'iconfont',
                  type == 1 ? 'icondanxuanxuanzhong' : 'iconweixuanzhong-',
                ]"
              ></i>
            </div>
            <div class="right">
              <div class="top">
                <span class="wx-info" v-if="phoneUser.headimg">
                  <img
                    :class="[
                      'common-head-img',
                      'avatar-border-style-' + phoneUser.sex,
                    ]"
                    :src="phoneUser.headimg"
                    alt=""
                  />
                  <span class="wx-name">{{ phoneUser.name }}</span>
                </span>
                <span class="not-bind" v-else>未绑定微信</span>
                <span class="phone-info"
                  >手机号:<span :class="[phoneUser.phone ? '' : 'not-bind']">{{
                    phoneUser.phone || "未绑定"
                  }}</span></span
                >
              </div>
              <div class="bottom">注册时间：{{ phoneUser.register_date }}</div>
            </div>
          </div>
          <div class="list-item" @click="type = '2'">
            <div class="left">
              <i
                :class="[
                  'iconfont',
                  type == 2 ? 'icondanxuanxuanzhong' : 'iconweixuanzhong-',
                ]"
              ></i>
            </div>
            <div class="right">
              <div class="top">
                <span class="wx-info" v-if="wxUser.headimg">
                  <img
                    :class="[
                      'common-head-img',
                      'avatar-border-style-' + wxUser.sex,
                    ]"
                    :src="wxUser.headimg"
                    alt=""
                  />
                  <span class="wx-name">{{ wxUser.name }}</span>
                </span>
                <span class="not-bind" v-else>未绑定微信</span>
                <span class="phone-info"
                  >手机号:<span :class="[wxUser.phone ? '' : 'not-bind']">{{
                    wxUser.phone || "未绑定"
                  }}</span></span
                >
              </div>
              <div class="bottom">注册时间：{{ wxUser.register_date }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <button class="button" :disabled="disabled" @click="confirm">
          确认绑定
        </button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Toast } from "vant";

export default {
  data() {
    return {
      visible: false,
      type: "",
      phoneUser: {
        passport_id: "",
        headimg: "",
        sex: 1,
        name: "",
        phone: "",
        register_date: "",
      },
      wxUser: {
        passport_id: "",
        headimg: "",
        sex: 1,
        name: "",
        phone: "",
        register_date: "",
      },
    };
  },

  computed: {
    disabled() {
      return !this.type;
    },
  },

  methods: {
    open(data) {
      if (!data.phone_user || !data.wx_user) {
        Toast.fail("请先传入正确的账号信息！");
        return;
      }
      this.phoneUser = data.phone_user || {};
      this.wxUser = data.wx_user || {};
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    confirm() {
      const data = {
        phone_passport_id: this.phoneUser.passport_id,
        wx_passport_id: this.wxUser.passport_id,
        target_passport_id:
          this.type == 1 ? this.phoneUser.passport_id : this.wxUser.passport_id,
      };
      this.$emit("confirm", data);
      this.close();
    },
  },
  comments: {},
};
</script>

<style lang="scss" scoped>
.alink {
  position: relative;
  width: 100%;
  height: 100%;
  .header {
    position: relative;
    display: flex;
    width: 100%;
    height: 50px;
    align-items: center;
    justify-content: space-between;
    padding-left: 10px;
    background-color: #fff;
    overflow: hidden;
    .title {
      font-weight: bold;
      font-size: 16px;
      color: #333;
    }
    .close {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50px;
      height: 100%;
    }
  }
  .body {
    .title {
      padding: 10px;
    }

    .content {
      padding: 10px;
      .list-item {
        display: flex;
        align-items: center;
        padding: 10px 0;
        border-bottom: 1px solid #ddd;
        &:last-child {
          border-bottom: none;
        }
        .left {
          flex: 0 0 40px;
          .iconfont {
            font-size: 20px;
          }
          .icondanxuanxuanzhong {
            color: #009688;
          }
          .iconweixuanzhong- {
            color: #999;
          }
        }
        .right {
          flex: 1;
          .top {
            display: flex;
            align-items: center;
            padding-bottom: 10px;
            .wx-info {
              display: flex;
              align-items: center;
            }
            .phone-info {
              margin-left: 20px;
            }
          }
        }
      }

      .not-bind {
        color: #ff0000;
      }
    }
  }
  .footer {
    padding: 10px;
    .button {
      width: 100%;
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 20px;
      font-weight: bold;
      color: #fff;
      background: #009688;
      box-shadow: 0 2px 5px 0 rgba(0, 150, 136, 0.6);
      border-radius: 10px;
      &:disabled {
        background: #ddd !important;
        color: #fff !important;
        font-weight: 400 !important;
        opacity: 1 !important;
        box-shadow: none !important;
      }
    }
  }
}
</style>
